module.exports = __webpack_public_path__ + "static/media/take_photo.6f90bfeb.mp3";